"use strict";
// Browsers aggressively throttle setTimeout in inactive tabs (clamped to >=1s,
// frozen entirely after a few minutes). A Web Worker's timers are not throttled,
// so we run the actual setTimeout inside a worker and post back when it fires.
// Falls back to a native setTimeout off the main thread (server, tests, no Worker).
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearTimeoutUnthrottled = exports.setTimeoutUnthrottled = void 0;
let worker;
let workerUnavailable = false;
let nextTimerId = 1;
const callbacks = new Map();
const nativeHandles = new Map();
const workerMain = () => {
    const handles = new Map();
    self.onmessage = (event) => {
        const message = event.data;
        if (message.type === "set-timeout") {
            const handle = setTimeout(() => {
                handles.delete(message.timerId);
                self.postMessage({
                    type: "fire",
                    timerId: message.timerId,
                });
            }, message.delay);
            handles.set(message.timerId, handle);
        }
        else if (message.type === "clear-timeout") {
            const handle = handles.get(message.timerId);
            if (handle !== undefined) {
                clearTimeout(handle);
                handles.delete(message.timerId);
            }
        }
    };
};
const getWorker = () => {
    if (worker || workerUnavailable) {
        return worker;
    }
    try {
        const source = `(${workerMain.toString()})();`;
        const url = URL.createObjectURL(new Blob([source], { type: "text/javascript" }));
        worker = new Worker(url);
        URL.revokeObjectURL(url);
        worker.onmessage = (event) => {
            const callback = callbacks.get(event.data.timerId);
            if (callback) {
                callbacks.delete(event.data.timerId);
                callback();
            }
        };
    }
    catch (_a) {
        workerUnavailable = true;
    }
    return worker;
};
const setTimeoutUnthrottled = (callback, delay) => {
    const timerId = nextTimerId++;
    const activeWorker = typeof Worker !== "undefined" ? getWorker() : undefined;
    if (!activeWorker) {
        nativeHandles.set(timerId, setTimeout(() => {
            nativeHandles.delete(timerId);
            callback();
        }, delay));
        return { id: timerId };
    }
    callbacks.set(timerId, callback);
    activeWorker.postMessage({ type: "set-timeout", timerId, delay });
    return { id: timerId };
};
exports.setTimeoutUnthrottled = setTimeoutUnthrottled;
const clearTimeoutUnthrottled = ({ id }) => {
    const nativeHandle = nativeHandles.get(id);
    if (nativeHandle !== undefined) {
        clearTimeout(nativeHandle);
        nativeHandles.delete(id);
        return;
    }
    callbacks.delete(id);
    worker === null || worker === void 0 ? void 0 : worker.postMessage({ type: "clear-timeout", timerId: id });
};
exports.clearTimeoutUnthrottled = clearTimeoutUnthrottled;
